import roadmapSprite from '@/assets/sprite/roadmap-sprite.svg';
import { numberFormat } from '@/utils/commonFunc';
import { useMemo } from 'react';
import './RResultCell.scss';
type ResultCellProps = {
    resultPoint: string;
    multiples?: boolean;
    payout?: number;
};
export const RResultCell = (props: ResultCellProps) => {
    const { resultPoint, multiples = false, payout = 0 } = props;
    const image = useMemo(
        () =>
            `${roadmapSprite}#carnivalTreasure__bead__result-${resultPoint}${multiples && payout > 0 ? '-multiplier' : ''}`,
        [resultPoint, multiples, payout]
    );
    const isMultiplier = useMemo(() => {
        return resultPoint === '2x' || resultPoint === '10x';
    }, [resultPoint]);
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            fill="none"
            viewBox="0 0 84 85"
            className="r-result-cell"
        >
            {isMultiplier ? (
                <>
                    <defs>
                        <linearGradient
                            id="text-multiplier"
                            x1="19.5838"
                            y1="9.76863"
                            x2="70.6235"
                            y2="34.4301"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="#FF8C64" />
                            <stop offset="0.333333" stopColor="#FFF148" />
                            <stop offset="0.666667" stopColor="#84FB79" />
                            <stop offset="1" stopColor="#FF6DF4" />
                        </linearGradient>
                    </defs>
                    <use href={image} fill="url(#text-multiplier)" />
                </>
            ) : (
                <use href={image} />
            )}
            {multiples && payout > 0 && (
                <ResultMultiplierText payout={payout} />
            )}
        </svg>
    );
};

type ResultMultiplierTextProps = {
    payout: number;
};
const ResultMultiplierText = ({ payout }: ResultMultiplierTextProps) => (
    <text
        x="50%"
        y="85%"
        textAnchor="middle"
        dominantBaseline="middle"
        fill="white"
        stroke="black"
        strokeWidth={4}
        strokeLinejoin="round"
        fontWeight={700}
        paintOrder="stroke"
        fontSize="24px"
    >
        {numberFormat(payout, 0)}X
    </text>
);
